/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';
import { referralsPostRequestSchema } from './referralsPostRequestSchema.ts';
import { referralsPostResponseSchema } from './referralsPostResponseSchema.ts';

/**
 * @description 200 response
 */
export const postReferrals200Schema = z.lazy(() => referralsPostResponseSchema);

/**
 * @description 505 response
 */
export const postReferrals505Schema = z.any();

export const postReferralsMutationRequestSchema = z.lazy(() => referralsPostRequestSchema);

export const postReferralsMutationResponseSchema = z.lazy(() => postReferrals200Schema);
